let env

if (typeof window !== 'undefined') {
  env = {
    ...window.__APP_STATE__.env,
  }
} else {
  env = {
    APP_ENV: process.env.APP_ENV,
    APP_VERSION: process.env.APP_VERSION,
    API_URL: process.env.API_URL,
    GOOGLE_API_KEY: process.env.GOOGLE_API_KEY,
    MEDIA_URL: process.env.MEDIA_URL,
    IMAGE_URL: process.env.IMAGE_URL,
    BLOG_URL: process.env.BLOG_URL,
    GA_TRACKING_ID: process.env.GA_TRACKING_ID,
    GA_CONVERSION_ID: process.env.GA_CONVERSION_ID,
    SENTRY_DSN: process.env.SENTRY_DSN,
    SLEEK_ORDER_URL: process.env.SLEEK_ORDER_URL,
    ENABLE_ORDER_AHEAD: process.env.ENABLE_ORDER_AHEAD,
  }
}

export default env
